<div class="detail-card">
  <ul class="detail-card-list">
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.ENTITY' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.entity.name) | infoDisplay }}
    </li>
    @if (site()?.type === SiteType.STOCK) {
      <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.NAME' | translate }}" class="detail-card-item">
        {{ $safeNavigationMigration(site()?.name) | infoDisplay }}
      </li>
    } @else {
      <li (click)="selectSite.emit(site())" attr.data-label="{{ 'DETAIL_CARD_COMPONENT.NAME' | translate }}" class="detail-card-item-navigable">
        {{ $safeNavigationMigration(site()?.name) | infoDisplay }}
      </li>
    }
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.TYPE' | translate }}" class="detail-card-item">
      {{ 'SITES.CARD.TYPES.' + $safeNavigationMigration(site()?.type) | translate }}
    </li>
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.CUSTOMER_NUMBER' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.customerNumber) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.ADDRESS_1' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.address.address1) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.ADDRESS_2' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.address.address2) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_CARD_COMPONENT.CITY' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(site()?.address) | infoDisplay: 'brackets' : 'city' : 'zipCode' }}
    </li>
  </ul>
</div>
